import type { StateCreator, StoreApi } from 'zustand';
import { createStore } from 'zustand';

export const createGenericStore = <T>(store: StateCreator<T>): StoreApi<T> => createStore<T>()(store);

export const createGenericStoreWithDevtools = <T>(
	store: StateCreator<T, [], [['zustand/devtools', never]], T>,
): StoreApi<T> => createStore<T>()(store);
